import axios from "axios";
import { loginRequest } from "./authProvider";

let msalInstanceRef = null;

export const initializeAxiosInterceptor = (msalInstance) => {
  msalInstanceRef = msalInstance;
};

axios.interceptors.request.use(
  async (config) => {
    if (!msalInstanceRef) {
      console.warn("MSAL instance not yet initialized for axios interceptor");
      return config;
    }

    const accounts = msalInstanceRef.getAllAccounts();
    
    if (accounts.length > 0) {
      const request = {
        ...loginRequest,
        account: accounts[0]
      };
      
      try {
        const response = await msalInstanceRef.acquireTokenSilent(request);
        config.headers.Authorization = `Bearer ${response.accessToken}`;
      } catch (error) {
        console.error("Token acquisition failed in axios interceptor:", error);
      }
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);